<template>
  <NtAiAssistantResponseMessage v-if="messageContent" :role="messageContent.role" :content="messageContent.content" />

  <template v-if="messageIsComplete">
    <NtAiAssistantMcpToolMessage v-for="(item, i) in mcpCallComponents" :key="i" :content="item" />
  </template>
</template>

<script>
import NtAiAssistantMcpToolMessage from './NtAiAssistantMcpToolMessage.vue'
import NtAiAssistantResponseMessage from './responses/NtAiAssistantResponseMessage.vue'

export default {
  components: {
    NtAiAssistantMcpToolMessage,
    NtAiAssistantResponseMessage
  },
  props: {
    message: {
      type: Object,
      required: true
    }
  },
  computed: {
    messageContent() {
      const messages = this.message.content?.filter((c) => c.type === 'message') || []
      return messages.length > 0 ? messages[0] : null
    },
    messageIsComplete() {
      return this.messageContent?.status === 'completed'
    },
    mcpCallComponents() {
      return this.message.content?.filter((c) => c.type === 'mcp_call') || []
    }
  }
}
</script>
